import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/lib/reveal";
import { CLINIC, IMAGES } from "@/lib/site";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

export const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" data-testid="about" className="py-24 md:py-32">
      <div className="container-x grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <Reveal className="overline font-bold tracking-[0.2em]">{t.about.overline}</Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-foreground leading-[1.1]">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-5 text-foreground/90 font-medium leading-relaxed text-base sm:text-lg">
              <p>{t.about.p1}</p>
              <p>{t.about.p2}</p>
              <p>{t.about.p3}</p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-4">
              <div>
                <div className="text-3xl sm:text-4xl font-extrabold text-foreground">{CLINIC.rating}★</div>
                <div className="text-xs sm:text-sm font-semibold text-muted-foreground mt-1">{t.about.stat1Label}</div>
              </div>
              <div>
                <div className="text-3xl sm:text-4xl font-extrabold text-foreground">08–21</div>
                <div className="text-xs sm:text-sm font-semibold text-muted-foreground mt-1">{t.about.stat2Label}</div>
              </div>
              <div>
                <div className="text-3xl sm:text-4xl font-extrabold text-accent">100%</div>
                <div className="text-xs sm:text-sm font-semibold text-muted-foreground mt-1">{t.about.stat3Label}</div>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 pt-6 border-t border-border flex flex-col gap-3.5">
              <div className="flex items-center gap-3">
                <img
                  src={IMAGES.drErlind}
                  alt="Dr. Erlind Mara - FizioFit Center"
                  className="w-12 h-12 rounded-full object-contain border-2 border-accent/40 bg-card p-1 shadow-xs"
                />
                <div>
                  <div className="text-sm font-extrabold text-foreground">Dr. Erlind Mara</div>
                  <div className="text-xs text-muted-foreground font-medium">
                    Diplomuar te UniZKM "Zoja e Këshillit të Mirë" · Metoda Mézières &amp; Maitland Concept
                  </div>
                </div>
              </div>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 text-sm sm:text-base font-bold text-accent hover:text-accent/80 transition-colors group"
              >
                <span>{t.aboutPage?.title || "Mëso më shumë mbi Dr. Erlind & Filozofinë Klinike"}</span>
                <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, scale: 1.04 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="relative aspect-[4/3] overflow-hidden rounded-sm border border-border shadow-sm"
          >
            <img src={IMAGES.about} alt="Ambienti i klinikës FizioFit Center" className="h-full w-full object-cover" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
